import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import { PackageCheck, Wrench } from 'lucide-react';
import RenderAdmin from './AdminRender';
import PurchaseFulfillment from './PurchaseFulfillment';

export default function ProductionWorkspace({ initialSection = 'setup' }) {
  const [section, setSection] = useState(initialSection);

  return (
    <div className="container-fluid p-4">
      <div className="mb-3">
        <h2 className="mb-1 d-flex align-items-center gap-2"><Wrench size={25} /> Production</h2>
        <p className="text-muted mb-0">Create customer accounts, prepare and assign devices, and complete WooCommerce fulfillment.</p>
      </div>

      <Nav variant="tabs" activeKey={section} onSelect={value => value && setSection(value)}>
        <Nav.Item>
          <Nav.Link eventKey="setup" className="d-flex align-items-center gap-2"><Wrench size={17} /> Account &amp; device setup</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="fulfillment" className="d-flex align-items-center gap-2"><PackageCheck size={17} /> Woo fulfillment</Nav.Link>
        </Nav.Item>
      </Nav>

      <div className="border border-top-0 rounded-bottom bg-white">
        {section === 'setup' ? <RenderAdmin /> : <PurchaseFulfillment />}
      </div>
    </div>
  );
}
